/**
 * Permission keys for feature access control
 * These correspond to features in the permission table
 */
export enum Permission {
  // Basic features (all plans)
  BASIC_USAGE = 'basic_usage',
  PROMPT_EDITING = 'prompt_editing',
  CONVERSATION_TEST = 'conversation_test',

  // Custom character (Free+ and above)
  CUSTOM_CHARACTER = 'custom_character',

  // Starter and above features
  FAQ_SETTING = 'faq_setting',
  MEDIA_LIBRARY = 'media_library',
  LINK_SETTING = 'link_setting',
  LINE_LOGIN = 'line_login',
  LINE_INTEGRATION = 'line_integration',

  // Standard and above features
  FORM_FUNCTION = 'form_function',
  VOICE_MODE = 'voice_mode',
  VOICE_SPEECH = 'voice_speech',
  ANALYTICS = 'analytics',
  INITIAL_SETUP = 'initial_setup',
  PAGE_CREATION = 'page_creation',
  SUPPORT = 'support',

  // Pro only features
  PRESS_RELEASE_SUPPORT = 'press_release_support',
  API_INTEGRATION = 'api_integration',
}
